module.exports = __webpack_public_path__ + "static/media/before-arrow-circle.38393c08.svg";